// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dark Mode stylings */

body.dark .tradegpt-widget__content {
  background: #1C1C1E;
}

body.dark .tradegpt-widget-username.tradegpt-widget-bot-name {
  color: #E4E5E8;
}

body.dark .tradegpt-widget-username {
  color: #5EEECD;
}

body.dark .tradegpt-widget__content__footer__input {
  background: #7A7A7A;
}

body.dark input.tradegpt-widget-query-input {
  color: #FFFFFF;
}

body.dark input.tradegpt-widget-query-input::placeholder {
  color: #FFF;
}

body.dark .tradegpt-widget__content__footer__hint {
  color: #E4E5E8;
}

body.dark .tradegpt-widget__content__get_started__title {
  color: #5EEECD;
}

body.dark .tradegpt-widget__content__get_started__item {
  border: 1px solid #5EEECD;
}

body.dark .tradegpt-widget__content__get_started__item__title {
  color: #5EEECD;
}

body.dark .tradegpt-widget-message-action svg {
  fill: #E4E5E8;
}

body.dark .tradegpt-widget__sidebar__content__prompt {
  border: 1px solid #5EEECD;
}

body.dark .tradegpt-widget-feedback-modal {
  background-color: #000;
}

body.dark .tracking-tighter {
  color: #FFF;
}

body.dark .tradegpt-widget-feedback-modal-header svg {
  fill: #fff;
}

body.dark .feedback-submit-button {
  border: 1px solid #5EEECD;
  color: #fff !important;
}

body.dark .feedback-submit-button:disabled {
  color: rgba(255, 255, 255, 0.26) !important
}

body.dark .feedback-submit-button svg {
  fill: #fff !important;
}

body.dark .tradegpt-widget-feedback-modal .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border: 1px solid #fff !important;
}

body.dark .tradegpt-widget-thankyou-message {
  color: #fff !important;
}
`, "",{"version":3,"sources":["webpack://./lib/assets/darkmode.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/* Dark Mode stylings */\r\n\r\nbody.dark .tradegpt-widget__content {\r\n  background: #1C1C1E;\r\n}\r\n\r\nbody.dark .tradegpt-widget-username.tradegpt-widget-bot-name {\r\n  color: #E4E5E8;\r\n}\r\n\r\nbody.dark .tradegpt-widget-username {\r\n  color: #5EEECD;\r\n}\r\n\r\nbody.dark .tradegpt-widget__content__footer__input {\r\n  background: #7A7A7A;\r\n}\r\n\r\nbody.dark input.tradegpt-widget-query-input {\r\n  color: #FFFFFF;\r\n}\r\n\r\nbody.dark input.tradegpt-widget-query-input::placeholder {\r\n  color: #FFF;\r\n}\r\n\r\nbody.dark .tradegpt-widget__content__footer__hint {\r\n  color: #E4E5E8;\r\n}\r\n\r\nbody.dark .tradegpt-widget__content__get_started__title {\r\n  color: #5EEECD;\r\n}\r\n\r\nbody.dark .tradegpt-widget__content__get_started__item {\r\n  border: 1px solid #5EEECD;\r\n}\r\n\r\nbody.dark .tradegpt-widget__content__get_started__item__title {\r\n  color: #5EEECD;\r\n}\r\n\r\nbody.dark .tradegpt-widget-message-action svg {\r\n  fill: #E4E5E8;\r\n}\r\n\r\nbody.dark .tradegpt-widget__sidebar__content__prompt {\r\n  border: 1px solid #5EEECD;\r\n}\r\n\r\nbody.dark .tradegpt-widget-feedback-modal {\r\n  background-color: #000;\r\n}\r\n\r\nbody.dark .tracking-tighter {\r\n  color: #FFF;\r\n}\r\n\r\nbody.dark .tradegpt-widget-feedback-modal-header svg {\r\n  fill: #fff;\r\n}\r\n\r\nbody.dark .feedback-submit-button {\r\n  border: 1px solid #5EEECD;\r\n  color: #fff !important;\r\n}\r\n\r\nbody.dark .feedback-submit-button:disabled {\r\n  color: rgba(255, 255, 255, 0.26) !important\r\n}\r\n\r\nbody.dark .feedback-submit-button svg {\r\n  fill: #fff !important;\r\n}\r\n\r\nbody.dark .tradegpt-widget-feedback-modal .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\r\n  border: 1px solid #fff !important;\r\n}\r\n\r\nbody.dark .tradegpt-widget-thankyou-message {\r\n  color: #fff !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
